import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import bladesLogo from "../../../../../src/assets/blades-in-the-dark/logo-blades-in-the-dark.png";
import sectionDivider from "../../../../../src/assets/blades-in-the-dark/banner-bitd.webp";
import "../../../../index.css";
import { ContentContainer } from "../../SessionSection";
import DriveThruAffiliateHeader from "../../driveThruAffiliateHeader/driveThruAffiliateHeader.component";
import { useEffect } from "react";
import NavDistricts from "./NavDistricts";
import NavCampaign from "./NavCampaign";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "0.7",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Special Elite",
  backgroundColor: "rgba(0, 0, 0, .7) ",
  color: "white",
  marginBottom: "15px",
};

const section1Data = [
  {
    title: "",
    text: (
      <div className="morkBorgFont morkBorgTitleText">
        <p align="center">
          <NavDistricts />
          <img
            src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-header-text-charhollow.webp"
            alt="Charhollow"
          />
        </p>
        <strong>A crowded district of tenements and stacked houses.</strong>{" "}
        This crowded district is home to the bulk of the{" "}
        <strong>workforce of the city</strong>—servants, dockers, sailors,
        stockyard and eelery workers, cabbies, and so on. It’s{" "}
        <strong>cheap, noisy, cramped</strong>, and <strong>sweltering</strong>{" "}
        from cookfires and hissing steam-pipes, but there’s a{" "}
        <strong>familial camaraderie</strong> among its residents that you won’t
        find anywhere else. The people of Charhollow are a true{" "}
        <strong>community</strong>, brought together by circumstance, but bound
        by ties of mutual support and care in stark contrast to the cutthroat
        ruthlessness that constitutes business as usual in the rest of the city.
        <img
          src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-header-charhollow.webp"
          alt="Charhollow"
        />
        <table className="district-table">
          <thead>
            <tr>
              <th>Description</th>
              <th>District Details</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td valign="top">
                <strong>Nutshell.</strong> Strangford estate, Sheets (tailors
                and anarchists), crowded tenements.
                <br />
                <strong>Scene:</strong> Laborers returning from work shout
                greetings to friends and families. Groups of people cook and eat
                together at communal cook-fires.
                <br />
                Children run wild, playing at hunt-and-peek and catch-the-ghost.
                <br />
                <strong>Streets:</strong> Steep inclines cut with crude stone
                stairs, twisting alleyways, dirt and cobblestones.
                <br />
                <em>Bridge Road, Canal Street, Hill Street.</em>
                <br />
                <strong>Buildings:</strong> Stacked one- or two-room homes,
                cheap tenements, ramshackle apartments, well-worn taverns and
                public houses.
                <br />
                <strong>Factions</strong>
                <ul>
                  <li>1. The Horde</li>
                  <li>2. Path of Echoes</li>
                  <li>3. Skovlander Refugees</li>
                  <li>4. The Billhooks</li>
                </ul>
              </td>
              <td valign="top">
                <img
                  src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-traits-charhollow.webp"
                  alt="Charhollow district traits"
                />
                <br />
                <em>
                  Operations against the citizenry in Charhollow are considered
                  on “hostile turf” for the purpose of generating heat.
                </em>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <h1>Charhollow Locations</h1>
        <strong>
          <u>Strangford House</u>
        </strong>
        : The grand, fenced estate of the powerful Strangford family perches on
        the hill of a private island overlooking Charhollow. Many who live in
        the district toil in Strangford’s factories and workhouses, and few miss
        the chance to throw the evil eye in their direction when they catch
        glimpse of their house on the hill.
        <br />
        <br />
        <strong>
          <u>Kellen&apos;s Pub</u>
        </strong>
        : One of the oldest pubs in the city, with a dizzying selection of
        Skovlander ales and whiskeys. Rich and poor alike rub elbows here to
        enjoy the traditional food and music with their drinks, though recently,
        the pub has become the target of masked anti-Skovlander bigots, who’ve
        vandalized the property and assaulted some patrons, shouting “No Skovs!”
        and “Skovs go home!”
        <br />
        <br />
        <strong>
          <u>Charhollow Market</u>
        </strong>
        : A public market fills the open square here, offering fair prices and
        decent goods to the local community.
        <br />
        <br />
        <strong>
          <u>The Sheets</u>
        </strong>
        : Washers, tailors, and seamstresses congregate in this neighborhood,
        filling the alleyways between the buildings with the billowing fabrics
        of their trade. A secret association of anarchists among the working
        class meets here to plot their schemes for revolution.
        <p>
          <a href="#pageTop">Back to Top</a>
        </p>
      </div>
    ),
  },
];

const BITDClasses_Districts_Charhollow = () => {
  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../../src/assets/blades-in-the-dark/mood-doskvol_street-scene-01.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.back = "fixed";
    document.body.style.backgroundRepeat = "no-repeat";
    document.body.style.backgroundAttachment = "fixed";
  }, []);

  return (
    <div>
      <Container>
        <Row>
          <Col>
            <div
              style={{
                backgroundColor: "transparent",
                fontFamily: "Orbitron",
              }}
            >
              <main role="main" className="inner cover text-center">
                <DriveThruAffiliateHeader
                  gameName="Blades in the Dark"
                  logo={bladesLogo}
                  productUrl="https://www.drivethrurpg.com/en/product/170689/blades-in-the-dark?affiliate_id=844642"
                />
              </main>
              <div style={pageHeader}>
                <h1 className="cover-heading">Blades in the Dark: Campaign</h1>
                <p className="lead leadExtra">
                  <NavCampaign />
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card style={cardStyle}>
              <a name="pageTop" href="#pageTop">
                {" "}
              </a>
              <img
                src={sectionDivider}
                className="BITD-section-divider"
                alt="section divider"
              />
              <Card.Body>
                <Card.Text>
                  <ContentContainer data={section1Data} />
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BITDClasses_Districts_Charhollow;
